import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[truncateText]'
})
export class TruncateTextDirective implements AfterViewInit{
  @Input() public tooltipText: string;
  @Input() public maxLength: number = 0;
  @Input() public more: number;
  @Input() public less: number;

  private element: HTMLElement;
  private showComplete: boolean = false;
  private originalText: string | null;
  private textToShow: string;

  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngAfterViewInit(): void {
    this.element = this.elementRef.nativeElement;
    this.originalText = this.element.textContent;
    this.textToShow = this.originalText ?? "";
    this.handleShow();
  }

  private handleShow()
  {
    if (this.originalText && this.originalText.length > this.maxLength && !this.showComplete)
    {
      this.textToShow = this.originalText.substring(0,this.maxLength) + "..."; 
      this.renderer.setStyle(this.element, 'display', 'block');
      this.renderer.setStyle(this.element, 'overflow', 'hidden');
      this.renderer.setStyle(this.element, 'textOverflow', 'ellipsis');

      this.element.innerHTML = this.textToShow;

      var span = this.renderer.createElement('span');
      this.renderer.setStyle(span, 'color', '#ff00ff');
      this.renderer.setStyle(span, 'cursor', 'pointer');
      this.renderer.addClass(span, 'lessMoreText');
      span.innerHTML = " " + this.more;

      this.renderer.appendChild(this.element, span);
    }
    else
    {
      this.textToShow = this.originalText ?? "";
      this.renderer.setStyle(this.element, 'display', '');
      this.renderer.setStyle(this.element, 'overflow', '');
      this.renderer.setStyle(this.element, 'textOverflow', '');
      
      this.element.innerHTML = this.textToShow;

      if (this.showComplete && this.originalText && this.originalText.length > this.maxLength)
      {
        var span = this.renderer.createElement('span');
        this.renderer.setStyle(span, 'color', '#ff00ff');
        this.renderer.setStyle(span, 'cursor', 'pointer');
        this.renderer.addClass(span, 'lessMoreText');
        span.innerHTML = " " + this.less;

        this.renderer.appendChild(this.element, span);
      }
    }
    
  }

  @HostListener('mouseenter') public enter(): void {
    if (this.originalText && this.originalText.length > this.maxLength)
    {
      this.renderer.setStyle(this.element, 'cursor', 'pointer');
      if (this.tooltipText !== undefined && this.tooltipText.length > 0) {
        this.element.title = this.tooltipText;
        return;
      } else if (this.element.nodeName === 'INPUT') {
        this.element.title = this.elementRef?.nativeElement?.value;
        return;
      }
      this.element.title = this.originalText ?? "";
    }
    else
    {
      this.renderer.setStyle(this.element, 'cursor', '');
      if (this.tooltipText === undefined || this.tooltipText.length === 0) {
        this.element.title = "";
      }
    }

  }

  @HostListener('click') public click(): void {
    this.showComplete = !this.showComplete;
    this.handleShow();
  }
}